import { IApplicationState } from '../../types/store';

export const selectDistance = (state: IApplicationState) => {
  const {
    filters: { commuteKmFrom, commuteKmTo, commuteDistanceType },
  } = state;

  return {
    commuteKmFrom: commuteKmFrom ?? undefined,
    commuteKmTo: commuteKmTo ?? undefined,
    commuteDistanceType: commuteDistanceType ?? undefined,
  };
};
